import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Chef.css';

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="chef_image" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="Chef's word" />
      <h1 className="headtext__cormorant">What we believe in</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote_image" />
          <p className="p__opensans">
            Hospitality-focused, dedicated to excellence, are just a few terms
            most often used to describe Gericht.{' '}
          </p>
        </div>
        <p className="p__opensans">
          {' '}
          Our personell are masters in thier craft who believe that dining and
          feeding goes well beyond the actual act. It is at the very core of
          what shapes our values, relationships and culture. We strive to
          deliver an experience that will remain a part of you whereeve life
          will take you{' '}
        </p>
      </div>

      <div className="app__chef-sign">
        <p>Kevin Luo</p>
        <p className="p__opensans">Chef & Founder</p>
        <img src={images.sign} alt="sign_image" />
      </div>
    </div>
  </div>
);

export default Chef;
